import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import Button from '@/components/molecules/button/button';
import styles from './login-curtain-invalid-step.module.scss';

export interface LoginCurtainInvalidStepProps {
  buttonText?: string;
  /** The class name to apply */
  className?: string;
  /** The text to show as a headline */
  headline?: string;
  /** The text to show as a label */
  label?: string;
  /** Callback function to be called when the button is clicked */
  onClick?: () => void;
  /** The text to show as a description */
  text?: string;
}

const LoginCurtainInvalidStep = ({
  buttonText,
  className,
  headline,
  label,
  onClick,
  text,
}: LoginCurtainInvalidStepProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      {label && (
        <div className={styles.label}>
          <Icon className={styles.icon} name="CloseFilled" size={52} />

          <Typography tagStyle="headingSmall" text={label} />
        </div>
      )}

      <div className={styles.header}>
        <Typography
          className={styles.headline}
          tagStyle="headingMedium"
          text={headline}
        />

        {text && <RichText className={styles.text} text={text} />}
      </div>

      <form className={styles.main}>
        <Button onClick={onClick} text={buttonText} variant="tertiary" />
      </form>
    </div>
  );
};

LoginCurtainInvalidStep.displayName = 'LoginCurtainInvalidStep';

export default LoginCurtainInvalidStep;
